/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboardingplacedescription2Inputs */

const en_onboardingplacedescription2 = /** @type {(inputs: Onboardingplacedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bar, café, club, restaurant: people come to you.`)
};

const de_onboardingplacedescription2 = /** @type {(inputs: Onboardingplacedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bar, Café, Club, Restaurant: Leute kommen zu dir.`)
};

/**
* | output |
* | --- |
* | "Bar, café, club, restaurant: people come to you." |
*
* @param {Onboardingplacedescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const onboardingplacedescription2 = /** @type {((inputs?: Onboardingplacedescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboardingplacedescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboardingplacedescription2(inputs)
	return de_onboardingplacedescription2(inputs)
});
export { onboardingplacedescription2 as "onboardingPlaceDescription" }